import { Component } from '@angular/core';
import { Platform, IonicPage, NavController, NavParams, LoadingController, AlertController, ActionSheetController, ModalController } from 'ionic-angular';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';

import { ChallengeProvider } from "../../providers/challenge/challenge";
import { Challenge } from '../../models/challenge.model';
import { EntryProvider } from '../../providers/entry/entry';
import { Entry } from '../../models/entry.model';

import { LoginPage } from '../auth/login';
import { ChallengesPage } from '../challenges/challenges';
import { RulesPage } from '../rules/rules';
import { TermsOfUsePage } from '../terms-of-use/terms-of-use';

import { fadeInOutAnimation } from '../../animations/fade-in-out';

@IonicPage()
@Component({
  selector: 'page-challenge-detail',
  templateUrl: 'challenge-detail.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class ChallengeDetailPage {

  challenge: Challenge;
  err: string;
  loading: boolean;
  packshots: Array<string>;

  newEntry: Entry;

  constructor(public storage: Storage, public platform: Platform, public navCtrl: NavController, public navParams: NavParams, public modalCtrl: ModalController, public translate: TranslateService, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public actionSheetCtrl: ActionSheetController, private camera: Camera, public challengeProvider: ChallengeProvider, public entryProvider: EntryProvider) {
    this.newEntry = new Entry({
      filename: '',
      comments: ''
    });
  }

  getChallenge() {
    this.loading = true;
    this.challengeProvider.getByID(this.navParams.get('id'))
      .subscribe(
        challenge => this.challenge = challenge,
        error => {
          this.err = <any>error;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  openRules(challenge) {
    this.storage.get('current_brand').then((brand) => {
      let rulesModal = this.modalCtrl.create(RulesPage, { content: challenge.rules }, { cssClass: brand.name });
      rulesModal.present();
    });
  }

  openTermsOfUse() {
    this.storage.get('current_brand').then((brand) => {
      let tosModal = this.modalCtrl.create(TermsOfUsePage, { showBackBtn: true }, { cssClass: brand.name });
      tosModal.present();
    });
  }

  disconnected() {
    this.navCtrl.setRoot(LoginPage, {
      disconnected: true
    });
  }

  getBase64Image(imageData: string) {
    return `data:image/jpeg;base64,${imageData}`;
  }

  selectPicture() {
    let actionSheet = this.actionSheetCtrl.create({
      title: this.translate.instant('ACTION_SHEETS_PICTURE_TITLE'),
      buttons: [
        {
          text: this.translate.instant('ACTION_SHEETS_TAKE_PICTURE'),
          icon: !this.platform.is('ios') ? 'camera' : null,
          handler: () => {
            this.takePicture();
          }
        }, {
          text: this.translate.instant('ACTION_SHEETS_OPEN_LIBRARY'),
          icon: !this.platform.is('ios') ? 'images' : null,
          handler: () => {
            this.openLibrary();
          }
        }, {
          text: this.translate.instant('ACTION_SHEETS_CANCEL'),
          role: 'cancel',
          icon: !this.platform.is('ios') ? 'close' : null
        }
      ]
    });
    actionSheet.present();
  }

  openLibrary() {
    const options: CameraOptions = {
      quality: 80,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY
    };

    this.camera.getPicture(options).then((imageData) => {
      this.newEntry.filename = imageData;
     }, (err) => {
      console.log(err);
     });
  }

  takePicture() {
    const options: CameraOptions = {
      quality: 80,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE
    };

    this.camera.getPicture(options).then((imageData) => {
      this.newEntry.filename = imageData;
     }, (err) => {
      console.log(err);
     });
  }

  canSend() {
    return (this.newEntry.filename);
  }

  send() {
    let loading = this.loadingCtrl.create({
      content: this.translate.instant('MSG_PLEASE_WAIT')
    });

    loading.present();

    let values = {
      filename: this.newEntry.filename,
      comments: this.newEntry.comments || null
    };

    this.entryProvider.create(this.challenge.id, values)
      .subscribe(
        entry => {},
        error => {
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: this.translate.instant('MODAL_ERROR_TITLE'),
            subTitle: this.translate.instant('MODAL_ERROR_CHALLENGE_ENTRY'),
            buttons: [
              this.translate.instant('BTN_OK')
            ]
          });
          alert.present();
        },
        () => {
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: this.translate.instant('MODAL_SUCCESS_TITLE'),
            subTitle: this.translate.instant('MODAL_SUCCESS_CHALLENGE_ENTRY'),
            buttons: [
              this.translate.instant('BTN_OK')
            ]
          });
          alert.present();
          this.navCtrl.setRoot(ChallengesPage);
        }
      );
  }

  ionViewDidLoad() {
    this.getChallenge();
  }

}



// WEBPACK FOOTER //
// ./src/pages/challenge-detail/challenge-detail.ts